import React, { Component } from 'react';
import PropTypes from 'prop-types';
// For image grid
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
// For dialog
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

// Grid styles (to be used as classes)

class Images extends Component {

	state = {
		images: null,
		title: null,
		open: false,
		setOpen: false,
		currentImg: null
	}

	handleOpen = (img) => {
		this.setState({open: true, currentImg: img});
	}
	handleClose = (value) => {
		this.setState({open: false})
	}


	render() {
		const { images, title } = this.props;
		// console.log(images);

		let imageList = images ? (
			images.map(img => 
			<GridListTile key={img.id}>
				<img src={img.largeImageURL} alt={img.type} />
				<GridListTileBar
					title={img.tags}
					subtitle={<span>by: {img.user}</span>}
					actionIcon={
						<IconButton onClick={() => this.handleOpen(img.largeImageURL)} aria-label="Zoom in">
							<ZoomInIcon />
						</IconButton>
					}
				/>
			</GridListTile>
			)
		) : (
			<div>Loading Images...</div>
		);

		return (
			<>
			<div className="Images">
				<h2 style={{ marginBottom: '20px'}}>Search results for '{title}':</h2>
				<GridList cellHeight={250} cols={3} className="">
					{imageList}
				</GridList>
			</div>
			<Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.state.open}>
				<img src={this.state.currentImg} id="simple-dialog-title" alt="..." style={{width:'100%'}} />
				<DialogActions>
					<Button onClick={this.handleClose}>Close</Button>
				</DialogActions>
			</Dialog>
			</>
		);
	}
}

Images.propTypes = {
	images: PropTypes.array.isRequired
}

export default Images;